import { Tooltip as MUITooltip } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import { uniqueId } from "lodash";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { engagementTypes } from "utils/Types";
import Typography from "./Typography";

interface Props {
  title?: string;
  children: any;
  variant?: "static" | "info";
  listDetails?: any;
}

const getColor = (val: string) => {
  if (val === engagementTypes.overdue) return tokens.Text.Feedback.Alert;
  else return tokens.Text.General.PrimaryBody;
};

const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUITooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: tokens.Background.General.Primary,
    minWidth: "253px",
    minHeight: "135px",
    border: `1px solid ${colors.Neutral.Neutral50}`,
    borderRadius: "16px",
    boxShadow: tokens.BoxShadow,
    padding: "20px",
    gap: "16px"
  }
}));
function ToolTip(props: Props) {
  const { title, children, variant = "static", listDetails } = props;
  if (variant === "static")
    return (
      <MUITooltip title={title} arrow placement="top" sx={{ cursor: "pointer" }}>
        {children}
      </MUITooltip>
    );
  else
    return (
      <HtmlTooltip
        title={
          listDetails === undefined || listDetails?.list?.length < 2 || !listDetails?.list?.length ? (
            ""
          ) : (
            <>
              <Typography variant="body2" showBold color={tokens.Text.General.PrimaryBody}>
                <ListItem> {listDetails?.title}</ListItem>
              </Typography>

              {listDetails?.list?.map((element: any) => (
                <ListItem
                  key={uniqueId("TOOLTIP_")}
                  secondaryAction={
                    <Typography
                      component={"span"}
                      color={getColor(element?.name)}
                      sx={{ position: "relative", right: 0 }}
                      variant="body2"
                      showBold
                    >
                      {element?.value}
                    </Typography>
                  }
                >
                  <ListItemText>
                    <Typography component={"span"} variant="body2" color={getColor(element?.name)}>
                      {element?.name}
                    </Typography>
                  </ListItemText>
                </ListItem>
              ))}
            </>
          )
        }
      >
        {children}
      </HtmlTooltip>
    );
}

export default ToolTip;
